import { useEffect, useState } from "react";
import { api } from "../../api/http";

function TrendBadge({ current, prev }) {
	if (prev === 0 && current === 0)
		return <span className="text-muted small">sin datos</span>;
	if (prev === 0)
		return (
			<span className="text-success small">
				<i className="ri-arrow-up-line" /> nuevo
			</span>
		);
	const pct = Math.round(((current - prev) / prev) * 100);
	if (pct > 0)
		return (
			<span className="text-success small">
				<i className="ri-arrow-up-line" /> {pct}%
			</span>
		);
	if (pct < 0)
		return (
			<span className="text-danger small">
				<i className="ri-arrow-down-line" /> {Math.abs(pct)}%
			</span>
		);
	return <span className="text-muted small">= sin cambio</span>;
}

export default function AdminDashboard() {
	const [stats, setStats] = useState({
		companies: null,
		courses: null,
		users: null,
		news: null,
	});
	const [detail, setDetail] = useState(null);

	useEffect(() => {
		api.get("/api/backoffice/dashboard-stats/")
			.then((r) => {
				setDetail(r.data);
				const summary = r.data?.summary ?? {};
				setStats({
					companies: summary.companies ?? null,
					courses: summary.course_templates ?? null,
					users: summary.users ?? null,
					news: summary.news ?? null,
				});
			})
			.catch(() => { });
	}, []);

	const trends = detail?.trends ?? {};

	return (
		<div className="container-fluid">
			<h2 className="mt-0">Panel</h2>

			{/* ── Tarjetas KPI principales ───────────────────────────────── */}
			<div className="row g-3">
				<div className="col-12 col-md-6 col-xl-3">
					<div className="card shadow-sm border-0 h-100">
						<div className="card-body">
							<div className="admin-title-block">
								<span>Organizaciones</span>
							</div>
							<div className="d-flex align-items-center justify-content-between admin-items">
								<div className="display-6">
									{stats.companies == null
										? "—"
										: stats.companies}
								</div>
								<i className="ri-building-2-line emp" />
							</div>
						</div>
					</div>
				</div>

				<div className="col-12 col-md-6 col-xl-3">
					<div className="card shadow-sm border-0 h-100">
						<div className="card-body">
							<div className="admin-title-block">
								<span>Usuarios</span>
							</div>
							<div className="d-flex align-items-center justify-content-between admin-items">
								<div className="display-6">
									{stats.users == null ? "—" : stats.users}
								</div>
								<i className="ri-user-3-line user" />
							</div>
							{trends.new_users_30d != null &&
								trends.new_users_30d > 0 && (
									<div className="mt-1">
										<span className="text-muted small me-1">
											Últimos 30 días:{" "}
											<strong>
												{trends.new_users_30d}
											</strong>
										</span>
										<TrendBadge
											current={trends.new_users_30d}
											prev={trends.new_users_prev_30d}
										/>
									</div>
								)}
						</div>
					</div>
				</div>

				<div className="col-12 col-md-6 col-xl-3">
					<div className="card shadow-sm border-0 h-100">
						<div className="card-body">
							<div className="admin-title-block">
								<span>Cursos catálogo</span>
							</div>
							<div className="d-flex align-items-center justify-content-between admin-items">
								<div className="display-6">
									{stats.courses == null
										? "—"
										: stats.courses}
								</div>
								<i className="ri-book-2-line catt" />
							</div>
						</div>
					</div>
				</div>

				<div className="col-12 col-md-6 col-xl-3">
					<div className="card shadow-sm border-0 h-100">
						<div className="card-body">
							<div className="admin-title-block">
								<span>Noticias publicadas</span>
							</div>
							<div className="d-flex align-items-center justify-content-between admin-items">
								<div className="display-6">
									{stats.news == null ? "—" : stats.news}
								</div>
								<i className="ri-article-line news" />
							</div>
						</div>
					</div>
				</div>
				<div className="col-12 col-md-6 col-xl-3">
					<div className="card shadow-sm border-0 h-100">
						<div className="card-body">
							<div className="admin-title-block">
								<span>Certificados descargados</span>
							</div>
							<div className="d-flex align-items-center justify-content-between admin-items">
								<div className="display-6">
									{detail?.certificates?.total ?? "—"}
								</div>
								<i className="ri-file-paper-2-line talks" />
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}
